export const DEFAULT_GOVERNMENT_FEE_PROCESSING_MARKUP = Object.freeze({
  enabled: false,
  rate: 0,
  previousRate: 3,
});

const MIN_RATE = 0.01;
const MAX_RATE = 10;
const DEFAULT_PREVIOUS_RATE = 3;

const toNumberOrZero = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : 0;
  }
  return 0;
};

const hasAtMostTwoDecimals = (value) =>
  Number(value.toFixed(2)) === value;

const isValidRate = (value) =>
  typeof value === "number" &&
  Number.isFinite(value) &&
  value >= MIN_RATE &&
  value <= MAX_RATE &&
  hasAtMostTwoDecimals(value);

export const normalizeGovernmentFeeProcessingMarkup = (config) => {
  if (!config || typeof config !== "object") {
    return { ...DEFAULT_GOVERNMENT_FEE_PROCESSING_MARKUP };
  }
  const previousRate = toNumberOrZero(config.previousRate);
  return {
    enabled: !!config.enabled,
    rate: toNumberOrZero(config.rate),
    previousRate: isValidRate(previousRate) ? previousRate : DEFAULT_PREVIOUS_RATE,
  };
};

export const disableGovernmentFeeProcessingMarkup = (config) => {
  const markup = normalizeGovernmentFeeProcessingMarkup(config);
  const previousRate = isValidRate(markup.rate)
    ? markup.rate
    : markup.previousRate;
  return {
    enabled: false,
    rate: 0,
    previousRate,
  };
};

export const enableGovernmentFeeProcessingMarkup = (config) => {
  const markup = normalizeGovernmentFeeProcessingMarkup(config);
  const rate = isValidRate(markup.previousRate)
    ? markup.previousRate
    : DEFAULT_PREVIOUS_RATE;
  return {
    enabled: true,
    rate,
    previousRate: rate,
  };
};

export const isValidGovernmentFeeProcessingMarkup = (config) => {
  const markup = normalizeGovernmentFeeProcessingMarkup(config);
  if (markup.enabled) {
    return isValidRate(markup.rate);
  }
  return markup.rate === 0;
};
